<template>
  <section class="account-container account-agency-container p-lg-2 p-mlg-3 p-xl-3 agency">
    <div class="account pr-0 agency">
      <div class="gradient-bg"></div>
      <div class="content-info">
        <div class="plan d-flex align-items-center">
          <img class="lighting-diamond" :src="publicPath + require('@/core/assets/pricing/diamond-lighting.svg')" />
          <span class="typo-paragraph14 ml-2"><b>Partner</b> Program</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import upperFirst from "@/plugins/lodash/upperFirst.js";
export default {
  name: "AgencyAccount",
  filters: {
    upper(value) {
      if (value)
        return value
          .trim()
          .split(" ")
          .map(word => {
            return upperFirst(word);
          })
          .join(" ");
      return "";
    }
  },
  props: {
    account: Object,
    shops: Object
  }
};
</script>
<style lang="scss" scoped>
.account-container {

  &.agency {
    border-bottom: 4px solid $mono1;
  }
  .account {
    background: inherit;
    @include trans-all;
    // box-shadow: 0px 7px 20px rgba(0, 24, 46, 0.15);

    .content-info {
      .plan {
        .lighting-diamond {
          filter: drop-shadow(0px 0px 10px rgba(113, 144, 255, 0.6));
        }
      }
    }

    .name {
      color: #fff;
      margin-bottom: 2px;
      cursor: pointer;
    }

    .plan {
      // max-height: 15px;
      white-space: pre !important;
      justify-content: center;
      margin-bottom: 16px;
      .expired {
        color: $accent-red;
      }
      .remain {
        color: $accent-green;
      }
      .see-plan {
        color: $textDarkModeHigh;
      }
    }

    &.agency {
      .name {
        color: $black1;
      }
      .plan {
        color: $mono1;
        margin-bottom: auto;
      }
    }
  }
}
.account-agency-container {
  background: $mono3;
  .account {
    .name {
      color: #fff;
      margin-bottom: 2px;
    }

    .capacity {

      i.icon {
        font-weight: 600;
      }
    }

    .agency {
      > span:first-child {
        display: flex !important;
      }
      .capacity {
        color: $neutral5;
      }
    }
  }
  .capacity,
  .plan {
    display: flex;
  }

  .plan {
    color: $cYellow;
  }

  .capacity {
    margin-left: auto;
    align-items: center;
  }

  .arrow {
    transform: rotate(-90deg);
    margin-left: 8px;
    margin-right: 14px;
    color: #fff;
  }
}
</style>
